// ng
import { Component, ViewEncapsulation, OnInit, Input, ViewChild } from '@angular/core';

// ext
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { find, cloneDeep, filter } from 'lodash';
import { SortDescriptor } from '@progress/kendo-data-query';

// local
import Report from 'src/app/models/report';
import { GenericGridComponent } from 'src/app/modules/shared/components/genericGrid/genericGrid.component';

@Component({
  selector: 'report-results',
  templateUrl: 'report.results.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None,

})
export class ReportResultsComponent implements OnInit {
  icons = {
    faClipboardCheck,
  };
  @Input() gridColumns: { [k: string]: string | {} }[] = [];
  @Input() gridData = [];
  @Input() selectedReport: Report;
  @ViewChild('genericGrid') genericGrid: GenericGridComponent;
  @Input() organizationFilterSet = false;
  sort: SortDescriptor[] = [];
  defaultSortColumns = ['OrganizationName', 'HCAAgencyNumber', 'SubscriberSSN'];
  additionalSortColumsByReport =
  {
    'Termed Accounts': ['TermEffectiveDate']
  };
  
  constructor() {}

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.selectedReport) {
      //reset paging and sorting
      this.genericGrid.scrollable = 'virtual';
      this.genericGrid.heightOffset = 250;
      this.genericGrid.height = window.innerHeight - this.genericGrid.heightOffset;
      this.genericGrid.state.skip = 0;

      let colsToSearchFor = this.defaultSortColumns;
      if (this.additionalSortColumsByReport[this.selectedReport.reportName])
        colsToSearchFor = colsToSearchFor.concat(this.additionalSortColumsByReport[this.selectedReport.reportName]);
      const applicableColumns = this.gridColumns.filter(g => colsToSearchFor.indexOf(g.field.toString()) > -1);
      const colToSortDescriptors: SortDescriptor[] = applicableColumns.map<SortDescriptor>(g => ({ dir: 'asc', field: g.field.toString()}));
      this.sort = colToSortDescriptors;
    }
  }
}
